import { Reaction } from '../../../common/reaction-block/reaction-block';
import { MaterialPageSectionsNames } from '../../../routes/material-page/material-page.constants';
import { MaterialType, PreviewsType } from '../../../routes/material-page/material-page.type';
import qualityEventsHelpers from '../quality-events.helpers';

export const MATERIAL_PAGE_EVENTS = {
    preview: {
        favShareSchoolAbtest: {
            schoolBtnClick() {
                qualityEventsHelpers.track({
                    type: 'FSAP_school-wishlist-click'
                });
            },
            shareBtnClick() {
                qualityEventsHelpers.track({
                    type: 'FSAP_share-click'
                });
            },
            favouriteBtnClick() {
                qualityEventsHelpers.track({
                    type: 'FSAP_favourite-click'
                });
            }
        },
        showMaterialPreview(materialInfo: MaterialType, source?: string) {
            qualityEventsHelpers.track({
                ...qualityEventsHelpers.extractMaterialsData(materialInfo),
                source,
                type: 'showMaterialPreview'
            });
        },
        zoomMaterialPreview() {
            qualityEventsHelpers.track({
                type: 'zoom-material-preview'
            });
        },
        selectThumbnail(materialInfo: MaterialType, source?: string) {
            qualityEventsHelpers.track({
                ...qualityEventsHelpers.extractMaterialsData(materialInfo),
                source,
                type: 'select-material-thumbnail'
            });
        },
        galleryCounterClick() {
            const extra = JSON.stringify({ isMobile: window.innerWidth < 991 });

            qualityEventsHelpers.track({
                type: 'gallery-counter-click',
                extra
            });
        },
        slideMaterialGalleryPreviews(isOtherInfoSection: boolean) {
            qualityEventsHelpers.track({
                type: isOtherInfoSection
                    ? 'other-section-slide-material-gallery-previews'
                    : 'slide-material-gallery-previews'
            });
        },
        slideMaterialGalleryPreviewsByArrowClick(direction: string) {
            qualityEventsHelpers.track({
                type: 'slide-material-gallery-previews-by-arrow-click',
                extra: direction
            });
        },
        slideMaterialGalleryPreviewsByEmptySpaceClick(direction: string) {
            qualityEventsHelpers.track({
                type: 'slide-material-gallery-previews-by-empty-space-click',
                extra: direction
            });
        },
        slide(materialInfo: MaterialType, direction: string, source?: string) {
            qualityEventsHelpers.track({
                ...qualityEventsHelpers.extractMaterialsData(materialInfo),
                source,
                type: 'slide-small-material-preview',
                extra: direction
            });
        },
        closeMaterialPreview(method: string) {
            qualityEventsHelpers.track({
                type: 'close-material-preview',
                extra: method
            });
        },
        clickOnGalleryMainImage() {
            qualityEventsHelpers.track({
                type: 'click-gallery-main-image'
            });
        },
        previewTap() {
            qualityEventsHelpers.track({
                type: 'mp_ImageTap'
            });
        },
        swipeMaterialPreviews(direction: 'left' | 'right', previewIndex: number) {
            const extra = JSON.stringify({ direction, previewIndex });

            qualityEventsHelpers.track({
                type: 'swipe-mobile-material-preview',
                extra
            });
        },
        previewRightClick(materialId: number) {
            qualityEventsHelpers.track({
                type: 'preview-right-click',
                extra: JSON.stringify(materialId)
            });
        },
        pinchZoomMaterialPreview(materialId: number, zoomedPreview: PreviewsType) {
            qualityEventsHelpers.track({
                type: 'pinch-zoom-material-preview',
                extra: JSON.stringify({ materialId, zoomedPreview })
            });
        },
        onThumbnailClick(
            {
                materialInfo,
                place = '',
                source = ''
            }: { materialInfo?: MaterialType; place?: string; source?: string }
        ) {
            const extraData = materialInfo ? qualityEventsHelpers.extractMaterialsData(materialInfo) : {}

            qualityEventsHelpers.track({
                ...extraData,
                source,
                extra: place,
                type: 'click-material-thumbnail'
            });
        },
        scrollThumbnailsByClick(direction: string) {
            qualityEventsHelpers.track({
                type: 'scroll-thumbnails-by-click',
                extra: `${direction}`
            });
        },
        viewMoreThumbnailClick() {
            qualityEventsHelpers.track({
                type: 'view-more-thumbnail-click'
            });
        },
        openGalleryByIconClick() {
            qualityEventsHelpers.track({
                type: 'open-gallery-by-icon-click'
            });
        }
    },
    mobileGallery: {
        expandIconClick(materialId: number, previewIndex: number, showMobileGallery: boolean) {
            const extra = JSON.stringify({ materialId, previewIndex, showMobileGallery });

            qualityEventsHelpers.track({
                type: 'expand-icon-click',
                extra
            });
        },
        previewTap(materialId: number, previewIndex: number) {
            const extra = JSON.stringify({ materialId, previewIndex });

            qualityEventsHelpers.track({
                type: 'mobile-preview-tap',
                extra
            });
        },
        closeCarouselGallery(materialId: number, lastSeenPreview: number) {
            const extra = JSON.stringify({ materialId, lastSeenPreview });

            qualityEventsHelpers.track({
                type: 'close-carousel-gallery',
                extra
            });
        },
        openCarouselGallery(materialId: number) {
            const extra = JSON.stringify({ materialId });

            qualityEventsHelpers.track({
                type: 'open-carousel-gallery',
                extra
            });
        },
        swipeCarouselPreviews(materialId: number, direction: 'left' | 'right', previewIndex: number) {
            const extra = JSON.stringify({ materialId, direction, previewIndex });

            qualityEventsHelpers.track({
                type: 'swipe-carousel-previews',
                extra
            });
        },
        pinchZoomPreview(materialId: number, previewIndex: number) {
            const extra = JSON.stringify({ materialId, previewIndex });

            qualityEventsHelpers.track({
                type: 'pinch-zoom-mobile-preview',
                extra
            });
        }
    },
    priceBlock: {
        addToCart(
            material: Material,
            materialItem: string | null,
            materialIndex?: number,
            from?: string,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            extraProp?: any
        ) {
            qualityEventsHelpers.track({
                ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex: materialIndex }),
                extra: JSON.stringify({ referrer: materialItem, from, ...extraProp }),
                type: 'addToCart'
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addToCartInactive(extra?: any) {
            qualityEventsHelpers.track({
                type: 'addToCart-inactive-redirect',
                extra: JSON.stringify(extra)
            });
        },
        buyNow(material: Material) {
            qualityEventsHelpers.track({
                ...qualityEventsHelpers.extractMaterialsData(material),
                type: 'addToCart',
                extra: 'buyNow'
            });
        }
    },
    showCopySharePopup() {
        qualityEventsHelpers.track({
            type: 'mp_ShareMaterial'
        });
    },
    socialShareBtn(extra: string) {
        qualityEventsHelpers.track({
            type: 'SocialShareButtonClick',
            extra
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    materialClick(extractedMaterialData: any, source?: string, variant?: string, internalPath?: string) {
        qualityEventsHelpers.track({
            ...extractedMaterialData,
            internal_path: internalPath,
            source,
            test_segment: variant,
            type: 'click'
        });
    },
    viewMaterial(materialData: MaterialType, materialItem: string | null) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(materialData),
            extra: JSON.stringify({ referrer: materialItem }),
            type: 'viewMaterial'
        });
    },
    showMoreMetadata(state: 'expand' | 'collapse') {
        qualityEventsHelpers.track({
            type: `mp_${state}_metadata`,
            extra: 'metadata'
        });
    },
    showMoreButton(extra: string) {
        qualityEventsHelpers.track({
            type: 'show-more-button-click',
            extra
        });
    },
    showInteractiveBundlePreview(material: Material) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material),
            source: 'bundle-list',
            type: 'showInteractiveBundlePreview'
        });
    },
    materialIdCopy(extra: { materialId: number; copiedText: string | undefined }) {
        qualityEventsHelpers.track({
            type: 'material-id-copy',
            extra: JSON.stringify(extra)
        });
    },
    titleCopy(extraInfo: { materialId?: number; copiedText?: string }) {
        qualityEventsHelpers.track({
            type: 'material-title-copy',
            extra: JSON.stringify(extraInfo)
        });
    },
    stickyNavTabClick(section: MaterialPageSectionsNames) {
        qualityEventsHelpers.track({
            type: 'sticky-nav-click',
            extra: section
        });
    },
    learnMoreButton(materialInfo: MaterialType) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(materialInfo),
            type: 'click-learn-more-button'
        });
    },
    closeMaterialDetailedInfo(materialInfo: MaterialType) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(materialInfo),
            type: 'close-material-detailed-info-modal'
        });
    },
    addToCartMaterialCardsCarousel(material: Material) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material),
            type: 'add-to-cart-material-cards-carousel'
        });
    },
    authorsBlock: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        followUpdate(extra: any) {
            qualityEventsHelpers.track({
                type: 'follow-change-author-block',
                extra: JSON.stringify(extra)
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        toAuthorPageBtn(extra: any) {
            qualityEventsHelpers.track({
                type: 'to-author-page-button-author-block',
                extra: JSON.stringify(extra)
            });
        }
    },
    starsRatingPopup() {
        qualityEventsHelpers.track({
            type: 'mp_ReviewsWidgetExpand'
        });
    },
    scrollToFeedbacksRatingModal() {
        qualityEventsHelpers.track({
            type: 'mp_clickScrollToReviews'
        });
    },
    sectionAppearance(materialId: number, cache: Set<string>, onFinally: () => void) {
        qualityEventsHelpers
            .track({
                type: 'material-page-sections-appearance',
                extra: JSON.stringify({
                    materialId,
                    sectionIds: Array.from(cache)
                })
            })
            .finally(() => {
                onFinally();
            });
    },
    navigateToAuthor(finallyCallback?: () => void) {
        qualityEventsHelpers
            .track({
                type: 'mp_NavigateToAuthor'
            })
            .finally(finallyCallback);
    },
    interactivePreviewBtnClick() {
        qualityEventsHelpers.track({
            type: 'viewInteractivePreview'
        });
    },
    subjectClassificationClick() {
        qualityEventsHelpers.track({
            type: 'mp_PillsTap',
            extra: 'subject-classification'
        });
    },
    categoriesClick() {
        qualityEventsHelpers.track({
            type: 'mp_PillsTap',
            extra: 'categories'
        });
    },
    followTheAuthor(state: 'follow' | 'unfollow') {
        qualityEventsHelpers.track({
            type: 'mp_FollowTheAuthor',
            extra: state
        });
    },
    feedbacksCommentsTabTap(tab: string | null) {
        qualityEventsHelpers.track({
            type: 'mp_FeedbackCommentsTabTap',
            extra: tab
        });
    },
    feedbackReaction(reactionType?: 'positive' | 'negative') {
        qualityEventsHelpers.track({
            type: reactionType === 'positive' ? 'mp_reviewLike' : 'mp_reviewDislike'
        });
    },
    commentReaction(updatedReactions: Reaction[]) {
        qualityEventsHelpers.track({
            type: 'mp_commentLike',
            extra: JSON.stringify({ updatedReactions })
        });
    },
    addComment(commentText?: string) {
        qualityEventsHelpers.track({
            type: 'comment',
            extra: commentText
        });
    }
};
